import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { LIVE_DATE, shouldFilter } from './lib/launch';
import NotLaunched from './containers/NotLaunched/NotLaunched';

let experience = <App />

if (shouldFilter() && new Date().getTime() < LIVE_DATE) {
    experience = <NotLaunched />
}

ReactDOM.render(experience, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
